import React, { Component } from 'react'
import { connect } from 'react-redux'
import Formsy from 'formsy-react'
import { cpf as CPF } from 'cpf-cnpj-validator'
import get from 'lodash.get'
import { withRouter, Link } from 'react-router-dom'
import { Icon, Button, Select, message } from 'antd'
import { slideOutLeft, slideInLeft, fadeIn } from 'react-animations'
import Radium, { StyleRoot } from 'radium'

import CustomInput from 'components/CustomInput/index'
import CustomRating from 'components/CustomRating/index'
import LoadTypeChip from 'components/LoadTypeChip/index'
import Card from 'components/Card/index'
import inputValidations from 'utils/inputValidations'
import VehicleToBindCard from 'screens/LoadsDetails/components/VehicleToBindCard/index'
import FoundDriversList from 'screens/LoadsDetails/components/FoundDriversList/index'
import NewDriverView from 'components/NewDriverView'
import { toFullCurrency, toPhoneFormat } from 'utils/numberFormatters'
import { showConfirm } from 'components/ConfirmModal/index'
import {
  findDriverByName,
  findDriverByCpf,
  findVehicleByPlate,
  pendingBindDriverAndVehicle,
  fetchLoadDetail,
  handleTrackerInformation,
  clearTrackingDeviceFields,
  onTrackingDeviceFields,
} from 'screens/LoadsDetails/actions'
import { fetchRecentDrivers } from 'screens/Drivers/actions'
import { VEHICLE_TYPE } from 'utils/fleetFormatter'
import { avatarURLParse } from 'utils/urlParser'
import Avatar from 'components/Avatar/index'

import {
  clearDriverToBind,
  clearVehicleToBind,
} from '../../../LoadsDetails/actions'

import css from './index.scss'

const Option = Select.Option

class BindDriverModal extends Component {
  state = {
    // driverPaymentNumber: 0,
    openTrackerModal: false,
    driverPaymentNumber: 1,
    driverToRegister: null,
    driversToSelect: null,
    showNewDriverForm: false,
    driverSearchEnabled: false,
    vehicleSearchEnabled: false,
    showDriversList: false,
    selectedDriver: null,
    driverSearchBy: 'cpf',
    vehicleSearchBy: 'ownFleet',
    isOpen: false,
    animation: {
      animation: 'x 300ms',
      animationName: Radium.keyframes(slideInLeft, 'slideInLeft'),
    },
    fadeInContainer: {
      animation: 'x 300ms',
      animationName: Radium.keyframes(fadeIn, 'fadeIn'),
    },
  }
  componentDidMount() {
    const { hashId, deliveryId } = this.props.load
    this.props.fetchLoadDetail({ hashId, deliveryId })
    this.props.fetchRecentDrivers(
      this.props.load.hashId,
      this.props.load.deliveryId,
    )
    const localClose = this.handleCloseAnimation
    if (this.props.changeDriver) {
      showConfirm({
        title: 'Deseja fazer a troca do motorista deste frete?',
        content:
          'Ao realizar a troca de motorista ou veículo deste frete, o embarcador será notificado que você fez a troca dos mesmos. Deseja continuar?',
        okText: 'Continuar',
        cancelText: 'Cancelar',
        onOk() {},
        onCancel() {
          localClose()
        },
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      this.setState({
        driverToRegister: nextProps.driverToRegister,
        selectedVehicle: nextProps.vehicleToBind,
        driversToSelect: nextProps.driversToSelect,
      })
    }
    if (nextProps.driverToBind) {
      this.setState({
        selectedDriver: nextProps.driverToBind,
      })
    }
    return null
  }

  handleCloseAnimation = () => {
    this.setState(
      {
        animation: {
          animation: 'x 300ms',
          animationName: Radium.keyframes(slideOutLeft, 'slideOutLeft'),
        },
      },
      () => {
        this.props.onCloseClick()
        this.props.clearDriverToBind()
        this.props.clearVehicleToBind()
      },
    )
  }

  handleBindDriverAndVehicle = (evt, vehicle) => {
    const { selectedDriver, selectedVehicle, driverPaymentNumber } = this.state
    const { load, flEnableTrackingDevice, mappedTrackingDeviceFields, flEnableCommunication, deliveryHash } =
      this.props

    const onOk = () => {
      const payload = {
        hashId: load.hashId,
        driverId: selectedDriver.id,
        vehicleId: selectedVehicle.id,
        driverPaymentNumber,
        deliveryId: load.deliveryId || get(load, 'deliveries[0].id', null),
        flEnableCommunication,
        deliveryHash,
      }
      this.props.bindDriverAndVehicle(
        payload,
        this.handleCloseAnimation,
      )
    }

    if (
      flEnableTrackingDevice &&
      selectedVehicle.primaryVehicle &&
      vehicle &&
      !vehicle.flTrackingDevice &&
      !vehicle.trackingDeviceId &&
      !mappedTrackingDeviceFields[vehicle.id].justify.length
    ) {
      this.props.handleTrackerInformation()
      this.setState({ isOpen: true })
      return
    }
    if (
      flEnableTrackingDevice &&
      selectedVehicle.primaryVehicle &&
      !selectedVehicle.primaryVehicle.flTrackingDevice &&
      mappedTrackingDeviceFields[selectedVehicle.primaryVehicle.id] &&
      !mappedTrackingDeviceFields[selectedVehicle.primaryVehicle.id].justify
        .length
    ) {
      this.props.handleTrackerInformation()
      this.setState({ isOpen: true })
      return
    }
    if (!driverPaymentNumber) {
      return message.error('Informe um pagamento válido para o motorista.')
    }
    const vehicleTypes = [
      ...(load.vehicleType || []),
      ...get(load, 'productProfile.vehicleType', []),
    ]

    let isCompatible = true
    const isBlock =
      selectedDriver.flBlock ||
      selectedVehicle.primaryVehicle.flBlock ||
      (!!selectedVehicle.secondaryVehicle1 &&
        selectedVehicle.secondaryVehicle1.flBlock) ||
      (selectedVehicle.secondaryVehicle2 &&
        selectedVehicle.secondaryVehicle2.flBlock) ||
      (selectedVehicle.secondaryVehicle3 &&
        selectedVehicle.secondaryVehicle3.flBlock)

    vehicleTypes.every((type) => {
      if (type === selectedVehicle.type) {
        isCompatible = true
        return false
      }
      return true
    })
    const vehiclesStr = vehicleTypes
      .map((item) => VEHICLE_TYPE[item])
      .join(', ')
    const modalContent = (
      <span>
        Verificamos que o tipo de veículo ideal para este frete é de tipo
        <span style={{ fontFamily: 'GloberBold' }}> ({vehiclesStr}) </span>e
        você selecionou um veículo do tipo
        <span style={{ fontFamily: 'GloberBold' }}>
          {' '}
          {VEHICLE_TYPE[selectedVehicle.type]}
        </span>
        .
        <br />
        Tem certeza que deseja prosseguir?
      </span>
    )
    const modalContentIsBlock = (
      <span>
        O Motorista e/ou veículo selecionado necessita passar por uma avaliação
        do Embarcador antes de ser adicionado. Deseja prosseguir com o vínculo?
        <br />
        Tem certeza que deseja prosseguir?
      </span>
    )

    if (isBlock) {
      const resetFields = this.props.onTrackingDeviceFields
      return showConfirm({
        title: 'Motorista e/ou veículo pendente de avaliação',
        content: modalContentIsBlock,
        okText: 'Atribuir mesmo assim',
        okType: 'danger',
        cancelText: 'Cancelar',
        zIndex: 1002,
        onOk() {
          onOk()
        },
        onCancel() {
          resetFields(selectedVehicle.primaryVehicle.id, true, '')
        },
      })
    }
    if (!isCompatible) {
      return showConfirm({
        title: 'O perfil da carga e do veículo selecionado diferem.',
        content: modalContent,
        okText: 'Atribuir mesmo assim',
        okType: 'danger',
        cancelText: 'Cancelar',
        zIndex: 1002,
        onOk() {
          onOk()
        },
        onCancel() {},
      })
    }
    this.props.clearTrackingDeviceFields()
    return onOk()
  }

  handleSearchDriverChange = (value) => {
    this.setState({
      driverSearchBy: value,
      driverToRegister: null,
      selectedVehicle: null,
      driversToSelect: null,
    })
  }

  handleSearchVehicleChange = (value) => {
    this.setState({
      selectedVehicle: null,
      vehiclePlate: '',
      vehicleSearchBy: value,
    })
  }

  handleSearchDriver = () => {
    this.setState({ selectedDriver: null })
    if (this.state.driverSearchBy === 'cpf') {
      this.props.findDriverByCpf(
        this.state.driverCpf,
        this.props.load.hashId,
        this.props.load.deliveryId,
      )
    } else {
      this.props.findDriverByName(
        this.state.driverName,
        this.props.load.hashId,
        this.props.load.deliveryId,
      )
    }
  }

  handleClearDriver = () => {
    this.setState({
      selectedDriver: null,
      driverName: '',
      driverCpf: '',
    })
    if (this.props.driverToBind) {
      this.props.clearDriverToBind()
    }
  }

  handleIsOpen = (value) =>
    (value
      ? this.setState({ isOpen: value })
      : this.setState({ isOpen: !this.state.isOpen }))

  handleSearchVehicle = () => {
    this.props.clearTrackingDeviceFields()
    this.props.findVehicleByPlate(
      this.state.vehiclePlate.replace(/\W/g, ''),
      this.props.load.hashId,
      this.props.load.deliveryId,
    )
  }

  handleClearVehicle = () => {
    this.setState({
      selectedVehicle: null,
      vehiclePlate: '',
    })
    if (this.props.vehicleToBind) {
      this.props.clearVehicleToBind()
    }
  }

  renderDriverSearchInput = () => {
    if (this.state.driverSearchBy === 'name') {
      return (
        <CustomInput
          name="nameDriver"
          placeholder="Buscar por nome"
          inputStyle={{ width: 300, height: 32, marginLeft: 16 }}
          formStyle={{ marginLeft: 0 }}
          onChange={(e) => this.setState({ driverName: e.target.value })}
          value={this.state.driverName}
          {...inputValidations('name')}
          required
        />
      )
    }
    return (
      <CustomInput
        name="cpfCnpj"
        mask="cpf"
        placeholder="Buscar por CPF"
        inputStyle={{ width: 300, height: 32, marginLeft: 16 }}
        onValueChange={(value) => this.setState({ driverCpf: value })}
        value={this.state.driverCpf}
        {...inputValidations('cpf')}
        required
      />
    )
  }

  renderRecentDrivers = () => {
    if (
      this.props.recentCreatedDrivers &&
      !this.state.selectedDriver &&
      !this.state.driverToRegister
    ) {
      return (
        <div className={css.column} style={{ marginTop: 8 }}>
          <span className={css.sectionTitle}>
            Motoristas cadastrados recentemente
          </span>
          <FoundDriversList
            drivers={this.props.recentCreatedDrivers}
            onDriverSelect={(selDriver) =>
              this.setState({
                selectedDriver: selDriver,
                driversToSelect: null,
              })
            }
          />
        </div>
      )
    }
    return null
  }

  renderDriverCard = () => {
    if (!this.state.selectedDriver) {
      return null
    }
    const driver = this.state.selectedDriver
    const linkedDriver = get(driver, 'infoShippingLinkedDriverOrVehicle', null)
    const path =
      linkedDriver &&
      (linkedDriver.deliveryType === 'LOT'
        ? `/loads/${linkedDriver.shippingHash}/details/delivery/${linkedDriver.deliveryId}`
        : `/loads/${linkedDriver.shippingHash}/details`)

    return (
      <div className={css.column} style={{ marginTop: 8 }}>
        <span className={css.sectionTitle} style={{ marginBottom: 8 }}>
          Motorista encontrado
        </span>
        <Card className={css.driverCard}>
          <div
            className={css.closeBtn}
            tabIndex={0}
            role="button"
            onClick={this.handleClearDriver}
          >
            <Icon type="close" />
          </div>
          <div className={css.row} style={{ marginTop: 8 }}>
            <div
              className={css.column}
              style={{ alignItems: 'center', width: 120 }}
            >
              <Avatar
                src={avatarURLParse(get(driver, 'profileImage', ''))}
                alt="Motorista"
                noPicture="/assets/icons/profile.svg"
                size="small"
              />
              <div style={{ marginTop: 8, textAlign: 'center' }}>
                <CustomRating value={driver.rating} disabled small />
              </div>
            </div>
            <div
              className={css.column}
              style={{ marginLeft: 16, alignItems: 'flex-start' }}
            >
              <span className={css.displayName} style={{ fontSize: 16 }}>
                {driver.name}
              </span>
              <span className={css.data} style={{ fontSize: 14, marginTop: 6 }}>
                {CPF.format(driver.cpf)}
              </span>
              <div className={css.row} style={{ alignItems: 'center' }}>
                <span
                  className={css.label}
                  style={{ fontSize: 14, marginTop: 6, marginLeft: 8 }}
                >
                  Data de nascimento:
                </span>
                <span
                  className={css.data}
                  style={{ fontSize: 14, marginTop: 6, marginLeft: 16 }}
                >
                  {driver.birthDate}
                </span>
              </div>
              <div className={css.row} style={{ alignItems: 'center' }}>
                <Icon type="phone" fill="#7906a9" />
                <span
                  className={css.data}
                  style={{ fontSize: 14, marginTop: 6, marginLeft: 8 }}
                >
                  {toPhoneFormat(driver.phone)}
                </span>
              </div>
            </div>
            <div
              className={css.column}
              style={{ marginLeft: 24, alignItems: 'flex-start', flex: 1 }}
            >
              <span className={css.label}>CNH</span>
              <span className={css.data}>{driver.cnhNumber}</span>
              <span className={css.label}>Validade</span>
              <span className={css.data}>{driver.cnhValidDate}</span>
            </div>
          </div>
          {driver.flBlock && (
            <div style={{ marginTop: 5 }}>
              <Icon type="warning" fill="#F62144" />
              <span
                className={css.data}
                style={{
                  fontSize: 14,
                  marginTop: 6,
                  marginLeft: 8,
                  color: '#F62144',
                }}
              >
                Motorista possui uma restrição cadastrada no Embarcador dessa
                carga
              </span>
            </div>
          )}
          {linkedDriver &&
            (linkedDriver.externalId ? (
              <div style={{ marginTop: 5 }}>
                <Icon type="warning" fill="#F62144" />
                <span
                  className={css.data}
                  style={{
                    fontSize: 14,
                    marginTop: 6,
                    marginLeft: 8,
                    color: '#F62144',
                  }}
                >
                  O motorista está vinculado à carga:
                </span>
                <Link className={css.link} to={path} target="_blank">
                  {linkedDriver.externalId}
                </Link>
              </div>
            ) : (
              <div style={{ marginTop: 5 }}>
                <Icon type="warning" fill="#F62144" />
                <span
                  className={css.data}
                  style={{
                    fontSize: 14,
                    marginTop: 6,
                    marginLeft: 8,
                    color: '#F62144',
                  }}
                >
                  O motorista está vinculado a outra carga.
                </span>
              </div>
            ))}
          {driver.infoShippingLinkedDriverOrVehicle && (
            <div style={{ marginTop: 5 }}>
              <Icon type="warning" fill="#F62144" />
              <span
                className={css.data}
                style={{
                  fontSize: 14,
                  marginTop: 6,
                  marginLeft: 8,
                  color: '#F62144',
                }}
              >
                Motorista está vinculado à carga:{' '}
                {driver.infoShippingLinkedDriverOrVehicle.externalId}
              </span>
              <Link to={path}>ver carga</Link>
            </div>
          )}
        </Card>
      </div>
    )
  }

  renderNewDriverForm = () => {
    if (
      (this.state.driverToRegister && !this.state.selectedDriver) ||
      (this.state.driversToSelect === 'NOT_FOUND' &&
        this.state.driverSearchBy === 'cpf')
    ) {
      const driver = this.state.driverToRegister
      if (driver) {
        return (
          <div className={css.column} style={{ marginTop: 8 }}>
            <span className={css.sectionTitle} style={{ marginBottom: 8 }}>
              Cadastrar Novo Motorista
            </span>
            <NewDriverView
              defaultValues="create"
              disabledName
              disabledCPF
              disabledGender
              disabledBirthDate
              name={driver.nome}
              cpf={driver.cpf.replace(/\W/g, '')}
              birthDate={driver.nascimento}
              gender={driver.genero === 'M' ? 'MASCULINO' : 'FEMININO'}
              showAllDriversButton
            />
          </div>
        )
      }
      return (
        <div className={css.column}>
          <span className={css.sectionTitle} style={{ marginBottom: 8 }}>
            Cadastrar Novo Motorista
          </span>
          <NewDriverView cpf={this.state.driverCpf} showAllDriversButton defaultValues="create" />
        </div>
      )
    }
    return null
  }

  renderVehicleCards = () => {
    const vehicle = this.state.selectedVehicle
    const { selectedDriver } = this.state
    const { hashId, deliveryId } = this.props.load
    const { flEnableTrackingDevice } = this.props
    const vehiclesToRender = []
    const load = {
      hashId,
      deliveryId,
      flEnableTrackingDevice,
    }
    let linkToEdit = `/vehicle/${get(vehicle, 'fleetId', null)}/own/edit`

    if (get(vehicle, 'fleet', false) === false) {
      linkToEdit = `/vehicle/${get(vehicle, 'id', null)}/third/edit`
    }

    if (vehicle === 'NOT_FOUND' && selectedDriver) {
      return <span className={css.warning}>Veículo não encontrado</span>
    }
    if (vehicle && selectedDriver) {
      vehiclesToRender.push(
        <VehicleToBindCard
          primaryKey="primaryVehicle"
          vehicle={vehicle.primaryVehicle}
          onCloseClick={this.handleClearVehicle}
          data={vehicle}
          load={load}
          isOpen={this.state.isOpen}
          isPendingResolution
          handleIsOpen={this.handleIsOpen}
          toBind={this.handleBindDriverAndVehicle}
        />,
      )
      vehiclesToRender.push(
        <VehicleToBindCard
          primaryKey="secondaryVehicle1"
          vehicle={vehicle.secondaryVehicle1}
          onCloseClick={this.handleClearVehicle}
          data={vehicle}
          load={load}
        />,
      )
      vehiclesToRender.push(
        <VehicleToBindCard
          primaryKey="secondaryVehicle2"
          vehicle={vehicle.secondaryVehicle2}
          onCloseClick={this.handleClearVehicle}
          data={vehicle}
          load={load}
        />,
      )
      vehiclesToRender.push(
        <VehicleToBindCard
          primaryKey="secondaryVehicle3"
          vehicle={vehicle.secondaryVehicle3}
          onCloseClick={this.handleClearVehicle}
          data={vehicle}
          load={load}
        />,
      )
      vehiclesToRender.push(
        <VehicleToBindCard
          primaryKey="secondaryVehicle4"
          vehicle={vehicle.secondaryVehicle4}
          onCloseClick={this.handleClearVehicle}
          data={vehicle}
          load={load}
        />,
      )
      vehiclesToRender.push(
        <VehicleToBindCard
          primaryKey="secondaryVehicle5"
          vehicle={vehicle.secondaryVehicle5}
          onCloseClick={this.handleClearVehicle}
          data={vehicle}
          load={load}
        />,
      )

      return (
        <div className={css.column}>
          <div
            className={css.row}
            style={{
              justifyContent: 'space-between',
              marginBottom: 8,
              alignItems: 'center',
            }}
          >
            <span className={css.sectionTitle} style={{ marginBottom: 8 }}>
              Veículo encontrado
            </span>

            <Link
              to={linkToEdit}
              params={{}}
              target="_blank"
              style={{ padding: 0 }}
            >
              <Button type="primary" icon="eye" size="small">
                Editar Veículo
              </Button>
            </Link>

          </div>
          {vehiclesToRender}
        </div>
      )
    }
    return null
  }

  renderVehicleInput = () => {
    if (this.state.selectedDriver) {
      return [
        <span className={css.sectionTitle}>Buscar veículo por placa</span>,
        <Formsy
          onValid={() => this.setState({ vehicleSearchEnabled: true })}
          onInvalid={() => this.setState({ vehicleSearchEnabled: false })}
        >
          <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Select
                defaultValue={this.state.vehicleSearchBy}
                style={{ width: 160 }}
                onChange={this.handleSearchVehicleChange}
              >
                <Option value="ownFleet">Frota própria</Option>
                <Option value="thirdFleet">Frota de terceiro</Option>
              </Select>
              <CustomInput
                name="plate"
                mask="plate"
                placeholder="Placa do veículo"
                inputStyle={{ width: 180, marginLeft: 16, height: 32 }}
                formStyle={{ marginLeft: 0 }}
                onChange={(e) =>
                  this.setState({ vehiclePlate: e.target.value })
                }
                value={this.state.vehiclePlate}
                {...inputValidations('plate')}
                required
              />
              <Button
                label="Buscar"
                style={{ marginLeft: 16 }}
                type="primary"
                onClick={this.handleSearchVehicle}
                htmlType="submit"
                icon="search"
                disabled={!this.state.vehicleSearchEnabled}
              >
                Buscar
              </Button>
            </div>
          </div>
        </Formsy>,
      ]
    }
    return null
  }

  renderFoundDrivers = () => {
    if (
      !this.state.selectedDriver &&
      this.state.driversToSelect &&
      this.state.driversToSelect.length &&
      this.state.driversToSelect !== 'NOT_FOUND'
    ) {
      return (
        <div className={css.column}>
          <span className={css.sectionTitle}>
            {`Motoristas encontrados (${this.state.driversToSelect.length})`}
          </span>
          <FoundDriversList
            drivers={this.state.driversToSelect}
            onDriverSelect={(selDriver) =>
              this.setState({
                selectedDriver: selDriver,
                driversToSelect: null,
              })
            }
          />
        </div>
      )
    } else if (this.state.driversToSelect === 'NOT_FOUND') {
      if (this.state.driverSearchBy === 'cpf') {
        // return this.renderNewDriverForm()
        return null
      }
      return (
        <div className={css.column} style={{ alignItems: 'center' }}>
          <span className={css.warning} style={{ marginBottom: 8 }}>
            Motorista não encontrado, verifique se o nome está correto ou para
            cadastrar um novo motorista, digite o CPF.
          </span>
        </div>
      )
    }
    return this.renderRecentDrivers()
  }

  renderDriverPaymentSection = () => [
    <span className={css.sectionTitle}>Valor pago ao motorista</span>,
    <Formsy>
      <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <CustomInput
            name="driverPayment"
            placeholder=""
            inputStyle={{ width: 300, marginLeft: -6 }}
            mask="price"
            onPriceChange={(price, priceNumber) =>
              this.setState({
                driverPayment: price,
                driverPaymentNumber: priceNumber,
              })
            }
            value={this.state.driverPayment}
            required
          />
        </div>
      </div>
    </Formsy>,
    <div className={css.column}>
      <div className={css.row} style={{ alignItems: 'center' }}>
        <Icon type="info-circle" theme="outlined" fill="#7906a9" />
        <span className={css.sectionTitle} style={{ marginLeft: 16 }}>
          Importante
        </span>
      </div>
      <span className={css.warning}>
        O valor a ser pago para o motorista será visualizado somente pelo
        motorista.
        <br />
        Nenhuma indústria será informada do valor a ser pago ao motorista pelo
        frete. Da mesma forma nenhum motorista é informado do valor acertado
        pelo total do frete.
      </span>
    </div>,
  ]

  renderDriverPayment = () => {
    const { load } = this.props
    if (this.state.selectedDriver) {
      return (
        <div className={css.column}>
          <div className={css.column} style={{ marginTop: 16 }}>
            <span className={css.sectionTitle}>Valor do frete</span>
            <span className={css.money}>
              {toFullCurrency(load.freightPrice)}
              <span>{load.deliveryType === 'LOT' ? '/ton' : null}</span>
            </span>
          </div>
          {/*
          {this.renderDriverPaymentSection()}
          */}
        </div>
      )
    }
    return null
  }

  render() {
    const hasVehicle =
      this.state.selectedVehicle && this.state.selectedVehicle !== 'NOT_FOUND'

    const linkedDriver = get(
      this.state,
      'selectedDriver.infoShippingLinkedDriverOrVehicle',
      null,
    )
    const linkedVehicle = get(
      this.state,
      'selectedVehicle.infoShippingLinkedDriverOrVehicle',
      null,
    )
    return (
      <StyleRoot>
        <div style={[this.state.fadeInContainer]} className={css.fullContainer}>
          <div
            onClick={this.handleCloseAnimation}
            tabIndex={0}
            role="button"
            style={{ height: '100%', cursor: 'default' }}
          />
          <div className={css.container} style={[this.state.animation]}>
            <div className={css.content}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <LoadTypeChip type={this.props.load.shippingType} />
                <span className={css.title} style={{ margin: 0, marginTop: 8 }}>
                  {`${this.props.load.externalId}`}
                </span>
                <span
                  className={css.title}
                  style={{ margin: 0, marginTop: 8, marginLeft: 8 }}
                >
                  - Atribuir motorista e veículo ao frete
                </span>
              </div>
              <div
                className={
                  !this.state.selectedDriver ? css.row : css.cardWrapper
                }
              >
                <div className={css.column} style={{ flex: 1 }}>
                  <span className={css.sectionTitle}>Motorista</span>
                  <Formsy
                    onValid={() => this.setState({ driverSearchEnabled: true })}
                    onInvalid={() =>
                      this.setState({ driverSearchEnabled: false })
                    }
                  >
                    <div
                      style={{ display: 'flex', flex: 1, flexDirection: 'row' }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Select
                          defaultValue={this.state.driverSearchBy}
                          style={{ width: 100 }}
                          onChange={this.handleSearchDriverChange}
                        >
                          <Option value="cpf">CPF</Option>
                          <Option value="name">Nome</Option>
                        </Select>
                        {this.renderDriverSearchInput()}
                        <Button
                          label="Buscar"
                          style={{ marginLeft: 16 }}
                          type="primary"
                          onClick={this.handleSearchDriver}
                          htmlType="submit"
                          icon="search"
                          disabled={!this.state.driverSearchEnabled}
                        >
                          Buscar
                        </Button>
                      </div>
                    </div>
                  </Formsy>
                  {this.renderFoundDrivers()}
                  {this.renderDriverCard()}
                  {this.renderDriverPayment()}
                  {this.renderNewDriverForm()}
                </div>
                <div
                  className={css.responsiveColumn}
                  style={{ flex: 1, marginLeft: 56 }}
                >
                  {this.renderVehicleInput()}
                  {this.renderVehicleCards()}
                  {this.state.selectedDriver ? (
                    <div className={css.column} style={{ marginTop: 16 }}>
                      <div className={css.row} style={{ marginTop: 15 }}>
                        <Link
                          to="/vehicles"
                          params={{}}
                          target="_blank"
                          style={{ marginTop: 16, padding: 0 }}
                        >
                          <Button type="primary" icon="eye">
                            Ver veículos disponíveis
                          </Button>
                        </Link>
                        <span className={css.orSeparator}>ou</span>
                        <Link
                          to="/vehicles/new"
                          params={{}}
                          target="_blank"
                          style={{ marginTop: 16, padding: 0 }}
                        >
                          <Button type="primary" icon="plus-circle">
                            Cadastrar novo veículo
                          </Button>
                        </Link>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className={css.footerActions}>
                <div className={css.buttonsWrapper}>
                  <Button onClick={this.handleCloseAnimation}>Cancelar</Button>
                  <Button
                    onClick={this.handleBindDriverAndVehicle}
                    type="primary"
                    style={{ marginLeft: 16 }}
                    disabled={
                      !this.state.selectedDriver ||
                      !hasVehicle ||
                      linkedDriver ||
                      linkedVehicle
                    }
                  >
                    Atribuir motorista e veículo
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyleRoot>
    )
  }
}

const mapStateToProps = (state) => ({
  driverToBind: state.loadsDetails.driverToBind,
  vehicleToBind: state.loadsDetails.vehicleToBind,
  driverToRegister: state.loadsDetails.driverToRegister,
  driversToSelect: state.loadsDetails.driversToSelect,
  recentCreatedDrivers: state.drivers.recentCreatedDrivers,
  flEnableTrackingDevice: state.loadsDetails.flEnableTrackingDevice,
  flEnableCommunication: state.loadsDetails.flEnableCommunication,
  deliveryHash: state.loadsDetails.deliveryHash,
  mappedTrackingDeviceFields: state.loadsDetails.mappedTrackingDeviceFields,
})

const mapActionsToProps = (dispatch) => ({
  fetchLoadDetail(payload) {
    dispatch(fetchLoadDetail(payload))
  },
  fetchRecentDrivers(shippingHash, deliveryId) {
    dispatch(fetchRecentDrivers(shippingHash, deliveryId))
  },
  findDriverByCpf(cpf, shippingHash, deliveryId) {
    dispatch(findDriverByCpf(cpf, shippingHash, deliveryId))
  },
  findDriverByName(name, shippingHash, deliveryId) {
    dispatch(findDriverByName(name, shippingHash, deliveryId))
  },
  findVehicleByPlate(plate, shippingHash, deliveryId) {
    dispatch(findVehicleByPlate(plate, shippingHash, deliveryId))
  },
  bindDriverAndVehicle(
    payload, cb,
  ) {
    dispatch(
      pendingBindDriverAndVehicle(
        payload,
        cb,
      ),
    )
  },
  clearTrackingDeviceFields() {
    dispatch(clearTrackingDeviceFields())
  },
  handleTrackerInformation() {
    dispatch(handleTrackerInformation())
  },
  onTrackingDeviceFields(id, addTrackingInformation, justify) {
    dispatch(onTrackingDeviceFields(id, addTrackingInformation, justify))
  },
  clearDriverToBind() {
    dispatch(clearDriverToBind())
  },
  clearVehicleToBind() {
    dispatch(clearVehicleToBind())
  },
})

export default withRouter(
  connect(mapStateToProps, mapActionsToProps)(BindDriverModal),
)
